/**
 * @module menu
 * @description メニューの開閉制御
 * @example
 * import './menu.js';
 * @howtouse
 * <button id="menu-button" aria-controls="menu" aria-label="メニューを開く">メニューボタン</button>
 * <nav id="menu" aria-hidden="true">
 *   <ul>
 *     <li><a href="#">ホーム</a></li>
 *     <li><a href="#">メニュー</a></li>
 *   </ul>
 * </nav>
 */

import { $ } from "./utils.js";

// Menu
const menuButton = $('#nav-button');
const menu = $('#nav');

// メニュー内のフォーカス可能な要素を取得
const focusableElements = menu.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

// メニューの状態を管理
let isMenuOpen = false;

// メニューの開閉を制御する関数
const toggleMenu = () => {
  isMenuOpen = !isMenuOpen;
  
  // WAI-ARIAの属性を更新
  menu.setAttribute('aria-hidden', !isMenuOpen);
  menuButton.setAttribute('aria-expanded', isMenuOpen);
  menuButton.setAttribute('aria-label', isMenuOpen ? 'メニューを閉じる' : 'メニューを開く');

  // メニューの表示/非表示を切り替え
  if (isMenuOpen) {
    menu.classList.remove('hidden');
    if (focusableElements.length) focusableElements[0].focus();
    $('body').classList.add('nav-open', 'overscroll-none', 'overflow-hidden');
  } else {
    menu.classList.add('hidden');
    menuButton.focus();
    $('body').classList.remove('nav-open', 'overscroll-none', 'overflow-hidden');
  }
};

menuButton.addEventListener('click', toggleMenu);

const mediaQuery = window.matchMedia('(min-width: 768px)');

const handleMediaChange = (element) => {
  if (element.matches) {
    menu.classList.remove('hidden');
    menu.setAttribute('aria-hidden', 'false');
  } else {
    menu.classList.add('hidden');
    menu.setAttribute('aria-hidden', 'true');
    isMenuOpen = false;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'メニューを開く');
  }
};

mediaQuery.addListener(handleMediaChange);
handleMediaChange(mediaQuery);

menu.addEventListener('click', (e) => {
  if (!mediaQuery.matches) {
    if (e.target.tagName === 'A' || e.target === menu) {
      toggleMenu();
    }
  }
});

// メニュー内でのキーボード操作
menu.addEventListener('keydown', (e) => {
  if (!isMenuOpen) return;

  const focusableArray = Array.from(focusableElements);
  const firstFocusable = focusableArray[0];
  const lastFocusable = focusableArray[focusableArray.length - 1];

  if (e.key === 'Escape') {
    toggleMenu();
    return;
  }

  // TABキーでのフォーカス制御
  if (e.key === 'Tab') {
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }
});
